import { DatePicker, DatepickerProps } from 'baseui/datepicker';
import es from 'date-fns/locale/es';
import { forwardRef } from 'react';

const LocalizedDatePicker = forwardRef<DatePicker, Omit<DatepickerProps, 'locale'>>((props, ref) => {
  return (
    <DatePicker
      ref={ref}
      locale={es}
      {...props}
    />
  );
});

export default LocalizedDatePicker;
